module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "450",
      "max-height": "calc(100vh - 150px)",
      "origin": "top right",
      "offset-y": "offset-y",
      "transition": "slide-y-transition"
    },
    model: {
      value: (_vm.showNewTicketDispatcher),
      callback: function($$v) {
        _vm.showNewTicketDispatcher = $$v
      },
      expression: "showNewTicketDispatcher"
    }
  }, [_c('card-generate-ticket', {
    on: {
      "close": _vm.closeGenerarNuevoTicket
    }
  })], 1), _c('v-navigation-drawer', {
    attrs: {
      "width": _vm.isMovil ? '100%' : '380',
      "app": "app",
      "temporary": "temporary",
      "dense": "dense",
      "right": "right"
    },
    on: {
      "input": function($event) {
        !_vm.drawer_settings && _vm.$refs.configuraciones.close()
      }
    },
    model: {
      value: (_vm.drawer_settings),
      callback: function($$v) {
        _vm.drawer_settings = $$v
      },
      expression: "drawer_settings"
    }
  }, [_c('configuraciones-app', {
    ref: "configuraciones",
    on: {
      "close": function($event) {
        _vm.drawer_settings = false
      }
    }
  })], 1), _c('v-navigation-drawer', {
    attrs: {
      "dense": "dense",
      "app": "app"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('div', {
          staticClass: "pa-2"
        }, [_c('v-btn', {
          attrs: {
            "block": "",
            "small": !_vm.isMovil,
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.logout()
            }
          }
        }, [_vm._v("Cerrar sesión")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.mini),
      callback: function($$v) {
        _vm.mini = $$v
      },
      expression: "mini"
    }
  }, [_c('v-list', {
    staticClass: "py-1",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    attrs: {
      "to": "/",
      "color": !_vm.$vuetify.theme.dark ? 'white' : ''
    }
  }, [_c('v-list-item-title', [_c('div', {
    staticClass: "d-flex jc-center ai-center"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/logo.png",
      "width": "55%"
    }
  }), _c('v-spacer'), _c('v-chip', {
    attrs: {
      "color": "primary"
    }
  }, [_c('small', {
    staticClass: "font-size-12"
  }, [_vm._v("Help Desk")])])], 1)])], 1)], 1), _c('v-divider'), _c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [_vm._l((_vm.menu), function(m, index) {
    return [(m.children && m.children.length) ? _c('v-list-group', {
      attrs: {
        "value": false,
        "prepend-icon": m.icon,
        "no-action": "no-action"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function() {
          return [_c('v-list-item-title', [_vm._v(_vm._s(m.name))])]
        },
        proxy: true
      }], null, true)
    }, _vm._l((m.children), function(child, index2) {
      return _c('v-list-item', {
        key: index2,
        attrs: {
          "to": child.path,
          "link": "link"
        }
      }, [_c('v-list-item-icon', [_c('v-icon', {
        domProps: {
          "textContent": _vm._s(child.icon)
        }
      })], 1), _c('v-list-item-title', {
        domProps: {
          "textContent": _vm._s(child.name)
        }
      }), (_vm.abiertos[child.key]) ? _c('v-chip', {
        attrs: {
          "color": "primary",
          "x-small": "x-small",
          "label": "label"
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.abiertos[child.key]))])]) : _vm._e()], 1)
    }), 1) : _c('v-list-item', {
      attrs: {
        "active-class": "secondary primary--text",
        "to": m.path,
        "link": "link"
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(m.icon))])], 1), _c('v-list-item-title', [_vm._v(_vm._s(m.name))]), (_vm.abiertos[m.key]) ? _c('v-chip', {
      attrs: {
        "color": "primary",
        "x-small": "x-small",
        "label": "label"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.abiertos[m.key]))])]) : _vm._e()], 1)]
  })], 2)], 1), _c('v-app-bar', {
    staticClass: "elevation-1",
    attrs: {
      "app": "app",
      "dense": "dense",
      "color": !_vm.$vuetify.theme.dark ? 'white' : ''
    }
  }, [_c('v-app-bar-nav-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }), _c('v-spacer'), (_vm.perfil === 'dispatcher') ? _c('v-btn', {
    staticClass: "ma-5",
    attrs: {
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.goToGenerarTicket()
      }
    }
  }, [_vm._v("Nuevo ticket")]) : _vm._e(), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-chip', _vm._g(_vm._b({
          staticClass: "pa-4",
          attrs: {
            "label": "label",
            "to": "/profile",
            "color": "background"
          }
        }, 'v-chip', attrs, false), on), [_c('v-avatar', {
          attrs: {
            "left": "left"
          }
        }, [_c('avatar-perfil', {
          attrs: {
            "usuario": _vm.username,
            "is-fetch": true
          }
        })], 1), _c('span', {
          staticClass: "font-weight-700"
        }, [_vm._v(_vm._s(_vm.nombre))])], 1)]
      }
    }])
  }, [_c('small', [_vm._v("Perfil de tu cuenta")])]), _c('notificaciones-app'), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "icon"
          },
          on: {
            "click": function($event) {
              _vm.drawer_settings = !_vm.drawer_settings
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("tune")])], 1)]
      }
    }])
  }, [_c('small', [_vm._v("Configuraciones de la aplicacion")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f057728","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_sidebar.vue
// module id = 519
// module chunks = 1